import React from 'react';
import { CopyButton } from './CopyButton';

export const CodeBlock = ({ children, language = 'html', copyText }) => {
  const textToCopy = copyText || (typeof children === 'string' ? children : children?.props?.children || '');
  
  return (
    <div className="relative">
      <div className="absolute top-2 right-2 z-10">
        <CopyButton text={textToCopy} />
      </div>
      <pre className="bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto">
        <code className={`language-${language}`}>
          {children}
        </code>
      </pre>
    </div>
  );
};